// extracted by mini-css-extract-plugin
export default {"searchIcon":"SearchInput_searchIcon__396tq"};